import dayjs from 'dayjs';
import React, {
  createContext,
  useState,
  type Dispatch,
  type ReactNode,
  type SetStateAction
} from 'react';

// 定义用户类型
interface ReservationSearchCriteria {
  city: string;
  checkInDate: string;
  checkOutDate: string;
  roomsAndGuests: {
    rooms: number;
    adults: number;
    children: number;
  };
  promoCode: string;
}

// 定义 Context 的类型
interface ReservationContextType {
  reservationSearchCriteria: ReservationSearchCriteria;
  setReservationSearchCriteria: Dispatch<SetStateAction<ReservationSearchCriteria>>;
}

// 创建 Context
const ReservationContext = createContext<ReservationContextType>({
  reservationSearchCriteria: {
    city: '',
    checkInDate: '',
    checkOutDate: '',
    roomsAndGuests: {
      rooms: 0,
      adults: 0,
      children: 0
    },
    promoCode: ''
  },
  setReservationSearchCriteria: () => {
    console.warn('setUser method is not implemented');
  }
});

// Provider 组件
interface ReservationProviderProps {
  children: ReactNode;
}

export const ReservationProvider: React.FC<ReservationProviderProps> = ({ children }) => {
  const [reservationSearchCriteria, setReservationSearchCriteria] =
    useState<ReservationSearchCriteria>({
      city: 'all',
      checkInDate: dayjs().format('YYYY-MM-DD'),
      checkOutDate: dayjs().add(1, 'day').format('YYYY-MM-DD'),
      roomsAndGuests: {
        rooms: 1,
        adults: 2,
        children: 0
      },
      promoCode: ''
    });
  return (
    <ReservationContext.Provider
      value={{
        reservationSearchCriteria,
        setReservationSearchCriteria
      }}>
      {children}
    </ReservationContext.Provider>
  );
};

export default ReservationContext;
